export default __webpack_public_path__ + "media/images/mailer-new/heading/password-07f6f2c66296435f19330957fd261c2f.png";